import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export const routes = [{
  name: 'menu.dashboard',
  key: 'dashboard',
  children: [{
    name: 'menu.dashboard.workplace',
    key: 'dashboard/workplace'
  }]
}, {
  name: 'menu.data.memory',
  key: 'data/memory'
}, {
  name: 'menu.data.conversation',
  key: 'data/conversation'
}, {
  name: 'menu.data.device',
  key: 'data/device'
}, {
  name: 'menu.data.actions',
  key: 'data/actions'
}, {
  name: 'menu.conversation.sessions',
  key: 'conversation/sessions'
}, {
  name: 'menu.platform',
  key: 'platform',
  children: [{
    name: 'menu.platform.devices',
    key: 'platform/devices'
  }, {
    name: 'menu.platform.tenants',
    key: 'platform/tenants'
  }, {
    name: 'menu.platform.apps',
    key: 'platform/apps'
  }, {
    name: 'menu.platform.apiKeys',
    key: 'platform/api-keys'
  }]
}, {
  name: 'menu.model.channels',
  key: 'model/channels'
}, {
  name: 'menu.skill.registry',
  key: 'skill/registry'
}, {
  name: 'menu.skill.tools',
  key: 'skill/tools'
}, {
  name: 'menu.knowledge.base',
  key: 'knowledge/base'
}, {
  name: 'menu.speech',
  key: 'speech',
  children: [{
    name: 'menu.speech.dialogue',
    key: 'speech/dialogue'
  }, {
    name: 'menu.speech.asr',
    key: 'speech/asr'
  }, {
    name: 'menu.speech.tts',
    key: 'speech/tts'
  }, {
    name: 'menu.speech.transcription',
    key: 'speech/transcription'
  }, {
    name: 'menu.speech.voiceprint',
    key: 'speech/voiceprint'
  }, {
    name: 'menu.speech.analysis',
    key: 'speech/analysis'
  }, {
    name: 'menu.speech.voiceclone',
    key: 'speech/voiceclone'
  }]
}, {
  name: 'menu.log.invocation',
  key: 'log/invocation'
}, {
  name: 'menu.system.settings',
  key: 'system/settings'
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;

    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach(item => {
    if (item.children) {
      item.children.forEach(child => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};

const useRoute = userPermission => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }

    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;

      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }

      if (!visible) {
        continue;
      }

      if (route.children && route.children.length) {
        const newRoute = { ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);

        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({ ...route
        });
      }
    }

    return arr;
  };

  const [permissionRoute, setPermissionRoute] = useState(routes);
  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];

    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }

    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};

export default useRoute;